import { render, staticRenderFns } from "./C_App_AcceptTermsNotification.vue?vue&type=template&id=0880ad96&scoped=true&"
import script from "./C_App_AcceptTermsNotification.vue?vue&type=script&lang=js&"
export * from "./C_App_AcceptTermsNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0880ad96",
  null
  
)

export default component.exports